/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmIszrRole extends GContentBase<SeznamAdmIszrRoleObj> {
        private seznamObj: SeznamAdmIszrRoleObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmIszrRoleObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmIszrRoleNew",
                contentCaption: "jres:33000754", //RC 33000754 : Agendov� role ISZR
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{agenda} - {agendova_role}"
                },
                gridSettings: {
                    columnOrder: "{0}agendova_role,nazev,poznamka,seznam_udaju,seznam_udaju_ros,dat_zmena,zmenu_prov_txt".format(this.agenda ? "" : "agenda,")
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmIszrRoleObj extends GAdmSeznamBase {
        agenda: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmIszrRole", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmIszrRole",
                newRecord: isNew,
                agendova_role: isNew == true ? null : data.agendova_role
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                "actNewDetail*",
                "actAddToComparison*",
                "actOpenDialogVyberovaSkupina*"
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000757").addField("gselectbox", Gordic.Prefabs.Select.szrsage(), { //RC 33000757 : Agenda
                name: "agenda",
                model: "model.agenda=value.agenda",
                dropdown: true,
                disabled: this.agenda ? true : false
            }) 
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.agenda)
                hardFilter["agenda"] = this.agenda;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.agenda)
                data["agenda"] = this.agenda;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmIszrRole.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.agenda),
                nazev: data["nazev"]
            }
        }
    }
}